"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = exports.BASE_CLASSNAME = void 0;
var _react = _interopRequireDefault(require("react"));
var TooltipPrimitive = _interopRequireWildcard(require("@radix-ui/react-tooltip"));
var _constants = require("../constants");
require("./Tooltip.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BASE_CLASSNAME = exports.BASE_CLASSNAME = "".concat(_constants.CSS_PREFIX, "-tooltip");
var Tooltip = _ref => {
  var open = _ref.open,
    defaultOpen = _ref.defaultOpen,
    onOpenChange = _ref.onOpenChange,
    _ref$side = _ref.side,
    side = _ref$side === void 0 ? 'top' : _ref$side,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    content = _ref.content,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Root, {
    open: open,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    delayDuration: 100
  }, /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Trigger, {
    asChild: true,
    className: "".concat(BASE_CLASSNAME, "__trigger")
  }, /*#__PURE__*/_react.default.createElement("span", {
    tabIndex: 0
  }, children)), /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Content, {
    side: side,
    align: align,
    className: "".concat(BASE_CLASSNAME, "__content")
  }, content, /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Arrow, {
    className: "".concat(BASE_CLASSNAME, "__arrow"),
    width: 32,
    height: 16
  })));
};
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map